import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "q-py-md text-h5 text-grey-5"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("p", _hoisted_1, "在上面的输入框输入关键词, 然后按回车进行搜索");
}